/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import SmallCalendarComponent from './SmallCalandarView'
import {CalandarFilterDropdown} from './CalandarFilterDropdown'
import {CalendarSortDropdown} from './CalendarSortDropdown'
import {Popover, OverlayTrigger, Button, Tooltip, Dropdown} from 'react-bootstrap'
import axios from 'axios'
import moment from 'moment'
import {CommonLoading} from '../../../../Utils/commonLoading'
import {useAuth} from '../../../modules/auth'
import {buildProfileImageUrl} from '../../../../Utils/fileUrlHelper'
import {getTotalAppointments} from '../../../../Utils/commonData'
import {appointmentsCallenderFilterData} from '../../../redux/tableSlice/tableSatate/interfaces'
import {appointmentsCallenderDate} from '../../../redux/tableSlice/tableSlice'
import CCPStatusButton from '../../Common/components/Appointments/CCPStatusButton'
import {AppointmentStatusBadge} from '../../../../components/AppointmentStatusBadge'
import {getAppointmentStatusCalendarStyle, isInterpreterAssigned} from '../../../../Utils/appointmentStatusUtils'
import './style.css'

const API_URL = process.env.REACT_APP_API_URL

// Add some CSS to style the event content
const styles = `
.fc-timegrid-slot-label {
  font-size: 10px !important; 
}
.fc-timeline-slot-cushion {
  font-size: 10px !important; 
  color: #333333 !important;
  font-weight: 500 !important;
}
.fc-timegrid-slot {
  height: 1rem;
  font-size: 0.95rem;
}
.event-content {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.event-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}
.event-title {
  font-size: 10px;
}
.fc-datagrid-table {
  font-size: 12px !important;
}
.fc .fc-datagrid-header .fc-datagrid-cell-cushion {
  font-weight: normal !important;
}
#small .fc-toolbar-title {
  font-size: 12px !important;
  margin-right: 10px !important;
}
#small .fc-col-header-cell .fc-col-header-cell-cushion {
  font-size: 8px !important;
}
#small .fc-daygrid-day-top {
    display: flex;
    justify-content: center;
}

.fc-daygrid-day-number {
  font-size: 8px !important;
}

 #small .fc .fc-col-header-cell-cushion {
  font-size: 8px !important;
  width: 2.3ch !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  padding: 0 !important;
}
  #small .fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {
  min-height: 0 !important;  
}
  #small .fc .fc-daygrid-day-number {
  font-size: 8px !important;
}
  #small .fc .fc-highlight {
  background-color: #a3a242 !important;
}
  #small .fc .fc-button {
  padding: 0.30rem .5rem !important;
}
  #small  .fc .fc-button-primary .fc-icon {
  font-size: 1rem !important;
}
  #small .fc .fc-highlight {
  background-color: #ebea9b !important;
}
  #small .fc-event-title-container {
  height: 1px !important;
}
  #small .fc-theme-standard td{
  cursor:pointer;
}
 #small .fc .fc-daygrid-day.fc-day-today{
  background-color: #f5f8fa !important;
 }
 #small .fc .fc-bg-event{
  opacity: 1 !important;
 }
`

// Helper function to get communication type abbreviation
const getCommunicationTypeAbbr = (communicationTypeIdentification: string, communicationType?: string): string => {
  // First check by identification
  if (communicationTypeIdentification) {
    switch (communicationTypeIdentification.toUpperCase()) {
      case 'ON_SITE':
        return 'OSI'
      case 'THIRD_PART_PLATFORM':
        return 'VIS'
    }
  }
  
  // Fallback to checking communicationType display name
  if (communicationType) {
    const lowerType = communicationType.toLowerCase()
    if (lowerType.includes('onsite') || lowerType.includes('on-site') || lowerType.includes('on site')) {
      return 'OSI'
    }
    if (lowerType.includes('third party') || lowerType.includes('3rd party') || lowerType.includes('platform')) {
      return 'VIS'
    }
  }
  
  // Default to OPI for telephonic/video
  return 'OPI'
}

const AppointmentFullCalendar = () => {
  const calendarRef = useRef<FullCalendar>(null)
  const navigate = useNavigate()
  const [appoinments, setAppoinments] = useState<any>([])
  const [resources, setResources] = useState<any>([])
  const [events, setEvents] = useState<any>([])
  const [isLoading, setIsLoading] = useState(false)
  const {currentUser} = useAuth()
  const dispath = useDispatch()
  const [availableDates, setAvailableDates] = useState<any>([])
  const [appointmentStatistics, setAppointmentStatistics] = useState<any>([])
  const [userDetails, setUserDetails] = useState<any>(null)
  const [rawAppointments, setRawAppointments] = useState<any>([])
  const [sortKey, setSortKey] = useState(0)
  // const [data, setdata] = useState({
  //   accounts: [],
  //   langs: [],
  //   serviceTypes: [],
  //   communicationTypes: [],
  // })
  const date = useSelector((state: any) => state.table.appointmentsCallender[0].date)
  const data = useSelector((state: any) => state.table.appointmentsCallender[0].filterData)
  const sortBy = useSelector((state: any) => state.table.appointmentsCallender[0].sortBy)
  const sortOrder = useSelector((state: any) => state.table.appointmentsCallender[0].sortOrder)

  const sortAppointments = (appointments: any[], sortByField: string, order: 'asc' | 'desc') => {
    return [...appointments].sort((a, b) => {
      let valueA: any, valueB: any
      switch (sortByField) {
        case 'time':
          valueA = new Date(a.startTime).getTime()
          valueB = new Date(b.startTime).getTime()
          break
        case 'client':
          valueA = a.customerName?.toLowerCase() || ''
          valueB = b.customerName?.toLowerCase() || ''
          break
        case 'language':
          valueA = a.languageTo?.toLowerCase() || ''
          valueB = b.languageTo?.toLowerCase() || ''
          break
        case 'communicationType':
          valueA = a.communicationType?.toLowerCase() || ''
          valueB = b.communicationType?.toLowerCase() || ''
          break
        case 'linguist':
          valueA = a.interpreterFirstName?.toLowerCase() || ''
          valueB = b.interpreterFirstName?.toLowerCase() || ''
          break
        default:
          valueA = new Date(a.startTime).getTime()
          valueB = new Date(b.startTime).getTime()
      }
      let comparison = 0
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.localeCompare(valueB)
      } else {
        comparison = valueA - valueB
      }
      return order === 'asc' ? comparison : -comparison
    })
  }

  useEffect(() => {
    const toolbarTitleSelector = '.fc-toolbar-chunk .fc-toolbar-title'
    const prevButtonSelector = 'button.fc-prev-button[title="Previous month"]'

    const handleButtonClick = () => {
      const titleElement = document.querySelector(toolbarTitleSelector) as HTMLElement | null
      if (titleElement) {
        const newMonthYear = titleElement.textContent || '' // Example: "October 2024"
        const [monthName, year] = newMonthYear.split(' ')
        if (!monthName || !year) return // Guard clause for invalid data

        const month = new Date(`${monthName} 1, ${year}`).getMonth() + 1 // Months are 0-based
        const date = new Date(parseInt(year), month - 1, 1) // First day of the month
        const formattedDate = date.toISOString()
        dispath(appointmentsCallenderDate(moment(formattedDate).local().format('YYYY-MM-DD')))
      }
    }

    const prevButton = document.querySelector(prevButtonSelector) as HTMLButtonElement | null
    if (prevButton) {
      prevButton.addEventListener('click', handleButtonClick)
    }

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          handleButtonClick()
        }
      })
    })

    const titleElement = document.querySelector(toolbarTitleSelector)
      ?.parentNode as HTMLElement | null
    if (titleElement) {
      observer.observe(titleElement, {
        childList: true,
        subtree: true,
        characterData: true,
      })
    }

    return () => {
      if (prevButton) {
        prevButton.removeEventListener('click', handleButtonClick)
      }
      observer.disconnect()
    }
  }, [])

  const fetchAppoinmentDetailsUsingDate = async (date: string, payload: any) => {
    setIsLoading(true)
    try {
      let response = await axios.post(
        `${API_URL}/Appoinment/get-appointents/filter/${date}`,
        payload
      )
      setAvailableDates(response?.data?.dates)
      setRawAppointments(response?.data?.appointments || [])
      setAppointmentStatistics(response?.data?.statics ?? 0)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (date) {
      fetchAppoinmentDetailsUsingDate(date, data)
    }
  }, [date])

  useEffect(() => {
    const selectedDate = moment(date).startOf('day')
    
    if (rawAppointments.length > 0) {
      const sortedAppointments = sortAppointments(rawAppointments, sortBy, sortOrder)
      setAppoinments(sortedAppointments)
      
      const newResources = sortedAppointments?.map((x: any, index: number) => ({
        id: x?.code,
        title: `${getCommunicationTypeAbbr(x?.communicationTypeIdentification, x?.communicationType)} ${x?.languageTo} - ${x?.customerName}`,
        order: index,
      }))
      
      setResources(newResources)
      setSortKey(prev => prev + 1)
      
      if (calendarRef.current) {
        const calendarApi = calendarRef.current.getApi()
        const existingResources = calendarApi.getResources()
        existingResources.forEach((resource: any) => resource.remove())
        newResources.forEach((resource: any) => calendarApi.addResource(resource))
      }

      setEvents(
        sortedAppointments.flatMap((x: any) => {
          const events: any[] = []
          const start = moment(x?.startTime)
          const end = moment(x?.endTime)
          const startDate = start.clone().startOf('day')
          const endDate = end.clone().startOf('day')
          const isEndDate = endDate.isSame(selectedDate, 'day')
          const isStartDate = startDate.isSame(selectedDate, 'day')

          // Only show appointment if it actually spans the selected date
          const spansSelectedDate = (
            (startDate.isBefore(selectedDate, 'day') || startDate.isSame(selectedDate, 'day')) &&
            (endDate.isAfter(selectedDate, 'day') || endDate.isSame(selectedDate, 'day'))
          )

          if (!spansSelectedDate) {
            return events // Skip appointments that don't span the selected date
          }

          const {color, textColor} = getAppointmentStatusCalendarStyle(x?.status)
          
          if (isStartDate && isEndDate) {
            // Appointment starts and ends on the selected date
            events.push({
              title: x?.code,
              start: start.format('YYYY-MM-DDTHH:mm:ss'),
              end: end.format('YYYY-MM-DDTHH:mm:ss'),
              avatar:
                buildProfileImageUrl(x?.requesterProfileImage) || `${toAbsoluteUrl('/media/avatars/blank.png')}`,
              resourceId: x?.code,
              color: color,
              textColor: textColor,
            })
          } else if (isStartDate && !isEndDate) {
            // Appointment starts on selected date but ends later
            events.push({
              title: x?.code,
              start: start.format('YYYY-MM-DDTHH:mm:ss'),
              end: selectedDate.clone().endOf('day').format('YYYY-MM-DDT23:59:59'),
              avatar:
                buildProfileImageUrl(x?.requesterProfileImage) || `${toAbsoluteUrl('/media/avatars/blank.png')}`,
              resourceId: x?.code,
              color: color,
              textColor: textColor,
            })
          } else if (!isStartDate && isEndDate) {
            // Appointment started earlier and ends on selected date
            events.push({
              title: x?.code,
              start: selectedDate.format('YYYY-MM-DDT00:00:00'),
              end: end.format('YYYY-MM-DDTHH:mm:ss'),
              avatar:
                buildProfileImageUrl(x?.requesterProfileImage) || `${toAbsoluteUrl('/media/avatars/blank.png')}`,
              resourceId: x?.code,
              color: color,
              textColor: textColor,
            })
          } else {
            // Appointment spans the selected date (started before and ends after)
            events.push({
              title: x?.code,
              start: selectedDate.format('YYYY-MM-DDT00:00:00'),
              end: selectedDate.clone().endOf('day').format('YYYY-MM-DDT23:59:59'),
              avatar:
                buildProfileImageUrl(x?.requesterProfileImage) || `${toAbsoluteUrl('/media/avatars/blank.png')}`,
              resourceId: x?.code,
              color: color,
              textColor: textColor,
            })
          }
          return events
        })
      )
    } else {
      // Clear appointments and resources when there are no appointments for the selected date
      setAppoinments([])
      setResources([])
      setEvents([])
      setSortKey(prev => prev + 1)
      
      if (calendarRef.current) {
        const calendarApi = calendarRef.current.getApi()
        const existingResources = calendarApi.getResources()
        existingResources.forEach((resource: any) => resource.remove())
      }
    }
  }, [rawAppointments, sortBy, sortOrder, date])

  const handleDateSelect = (selectInfo: any) => {
    dispath(appointmentsCallenderDate(moment(selectInfo?.startStr).local().format('YYYY-MM-DD')))
  }

  useEffect(() => {
    // Initialize FullCalendar instance and store it in ref
    if (calendarRef.current) {
      // Configure FullCalendar with plugins and initial options
      calendarRef.current.getApi().gotoDate(date) // Initial gotoDate call
    }
  }, [date])

  const renderEventContent = (eventInfo: any) => {
    const time = eventInfo.timeText
    const appoimentDetails = appoinments.find((x: any) => x?.code == eventInfo?.event?.title)

    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement='top'
        delay={{show: 200, hide: 100}}
        overlay={
          <Popover id={`popover-${eventInfo?.event?.title}`} style={{minWidth: '380px'}}>
            <Popover.Header as='h5' className='py-3 bg-white border-bottom'>
              <div className='fw-bold fs-6 text-dark mb-1'>{appoimentDetails?.customerName}</div>
              <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                <span className='text-gray-600 fs-7'>{appoimentDetails?.requesterName || 'N/A'}</span>
                <div className='d-flex align-items-center gap-2'>
                  <AppointmentStatusBadge
                    statusName={appoimentDetails?.statusName}
                    status={appoimentDetails?.status}
                    className='fs-8 py-1 px-2'
                  />
                  {appoimentDetails?.meetingClientStatus && (
                    <span className='badge badge-light-primary fs-8'>{appoimentDetails?.meetingClientStatus}</span>
                  )}
                </div>
              </div>
            </Popover.Header>
            <Popover.Body className='py-3'>
              <div className='d-flex' style={{gap: '24px', alignItems: 'flex-start'}}>
                {/* Left Column: Primary Information */}
                <div className='d-flex flex-column' style={{flex: '1', minWidth: 0, gap: '12px'}}>
                  {/* Communication Type */}
                  <div className='d-flex align-items-center'>
                    <div style={{width: '18px', marginRight: '8px', flexShrink: 0}}></div>
                    <span className='text-gray-700 fs-7' style={{lineHeight: '1.5'}}>
                      {appoimentDetails?.communicationType || appoimentDetails?.serviceType || 'N/A'}
                    </span>
                  </div>
                  {/* Interpreter Name */}
                  <div className='d-flex align-items-center'>
                    <div style={{width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '8px', flexShrink: 0}}>
                      <i className='bi bi-person text-gray-500 fs-7' style={{lineHeight: '1'}}></i>
                    </div>
                    <span className='text-gray-700 fs-7' style={{lineHeight: '1.5'}}>
                      {isInterpreterAssigned(appoimentDetails?.status) && appoimentDetails?.interpreterFirstName
                        ? `${appoimentDetails?.interpreterFirstName} ${appoimentDetails?.interpreterLastName || ''}`
                        : 'Not Assigned'}
                    </span>
                  </div>
                  {/* Location */}
                  {(appoimentDetails?.Address || appoimentDetails?.address) && (
                    <div className='d-flex align-items-start'>
                      <div style={{width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '8px', flexShrink: 0, marginTop: '2px'}}>
                        <i className='bi bi-geo-alt text-gray-500 fs-7' style={{lineHeight: '1'}}></i>
                      </div>
                      <span className='text-gray-600 fs-7' style={{lineHeight: '1.5'}}>
                        {appoimentDetails?.Address || appoimentDetails?.address || ''}
                      </span>
                    </div>
                  )}
                </div>
                
                {/* Right Column: Metadata (Language & Time) */}
                <div className='d-flex flex-column' style={{flex: '0 0 auto', gap: '10px', alignItems: 'flex-start'}}>
                  {/* Language */}
                  <div className='d-flex align-items-center'>
                    <div style={{width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '8px', flexShrink: 0}}>
                      <i className='bi bi-translate text-gray-500 fs-7' style={{lineHeight: '1'}}></i>
                    </div>
                    <span className='text-gray-700 fs-7' style={{lineHeight: '1.5'}}>
                      {appoimentDetails?.languageFrom} - {appoimentDetails?.languageTo}
                    </span>
                  </div>
                  {/* Time */}
                  <div className='d-flex align-items-center'>
                    <div style={{width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '8px', flexShrink: 0}}>
                      <i className='bi bi-clock text-gray-500 fs-7' style={{lineHeight: '1'}}></i>
                    </div>
                    <span className='text-gray-700 fs-7' style={{lineHeight: '1.5'}}>
                      {moment(appoimentDetails?.startTime).format('h:mm A')} - {moment(appoimentDetails?.endTime).format('h:mm A')}
                    </span>
                  </div>
                </div>
              </div>
            </Popover.Body>
          </Popover>
        }
      >
        <div 
          className='event-content' 
          onClick={() => navigate(`/appointmentViewer/${appoimentDetails?.code}`)}
        >
          <span className='event-title'>{eventInfo?.event?.title}</span>
        </div>
      </OverlayTrigger>
    )
  }

  useEffect(() => {
    if (currentUser?.result.code) {
      getUserDetailsById(currentUser?.result.code)
    }
  }, [currentUser])

  const getUserDetailsById = async (id: any) => {
    try {
      const response = await axios.get(`${API_URL}/accounts/GetAccountDetailByID/${id}`)

      setUserDetails(response.data)
    } catch (error) {
      console.error('Error fetching user details:', error)
    }
  }

  const [showCalendarDropdown, setShowCalendarDropdown] = useState(false)

  const handlePrevDay = () => {
    const prevDay = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
    dispath(appointmentsCallenderDate(prevDay))
  }

  const handleNextDay = () => {
    const nextDay = moment(date).add(1, 'day').format('YYYY-MM-DD')
    dispath(appointmentsCallenderDate(nextDay))
  }

  return (
    <>
      <div className='row g-2'>
        <div className='col-12'>
          <div className='mb-2 d-flex justify-content-between align-items-center flex-wrap'>
            <div className='d-flex flex-row align-items-center'>
              <button
                type='button'
                className='btn btn-sm btn-light-primary btn-icon me-2'
                onClick={handlePrevDay}
                style={{width: '32px', height: '32px'}}
              >
                <i className='bi bi-chevron-left fs-5'></i>
              </button>
              
              <Dropdown 
                className='me-2' 
                show={showCalendarDropdown} 
                onToggle={(isOpen) => setShowCalendarDropdown(isOpen)}
              >
                <Dropdown.Toggle
                  variant='light'
                  id='dropdown-calendar-picker'
                  className='btn btn-sm d-flex align-items-center border no-caret'
                >
                  <i className='bi bi-calendar3 me-2 text-primary'></i>
                  <span style={{fontWeight: 700, color: '#181c32'}}>
                    {moment(date).format('dddd, MMMM D, YYYY')}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className='p-2' style={{minWidth: '280px'}}>
                  <SmallCalendarComponent availableDates={availableDates} onDateSelect={() => setShowCalendarDropdown(false)} />
                </Dropdown.Menu>
              </Dropdown>
              
              <button
                type='button'
                className='btn btn-sm btn-light-primary btn-icon me-3'
                onClick={handleNextDay}
                style={{width: '32px', height: '32px'}}
              >
                <i className='bi bi-chevron-right fs-5'></i>
              </button>

              <Dropdown className='me-2'>
                <Dropdown.Toggle
                  variant='light'
                  id='dropdown-appointments-stats'
                  className='btn btn-sm d-flex align-items-center no-caret'
                >
                  <span className='fw-semibold'>
                    Total Appointments ({Math.ceil(
                      Number(
                        getTotalAppointments(currentUser?.result.userType, appointmentStatistics)
                      ) || 0
                    )})
                  </span>
                  <i className='bi bi-chevron-down ms-2'></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className='p-3' style={{minWidth: '200px'}}>
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(215, 56, 60, 0.7)'}}></span>
                      <span className='fs-7 text-gray-700'>Open</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>
                      {currentUser?.result.userType === 'CONSUMER'
                        ? (appointmentStatistics?.open ?? 0) + (appointmentStatistics?.readyToAssign ?? 0)
                        : appointmentStatistics?.open ?? 0}
                    </span>
                  </div>
                  {currentUser?.result.userType !== 'CONSUMER' && (
                    <div className='d-flex justify-content-between align-items-center py-2'>
                      <div className='d-flex align-items-center'>
                        <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(163, 162, 66, 0.7)'}}></span>
                        <span className='fs-7 text-gray-700'>Ready to Assign</span>
                      </div>
                      <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.readyToAssign ?? 0}</span>
                    </div>
                  )}
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(96, 187, 26, 0.7)'}}></span>
                      <span className='fs-7 text-gray-700'>Confirmed</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.confirmed ?? 0}</span>
                  </div>
                  {currentUser?.result.userType !== 'CONSUMER' && (
                    <div className='d-flex justify-content-between align-items-center py-2'>
                      <div className='d-flex align-items-center'>
                        <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(255, 199, 0, 0.7)'}}></span>
                        <span className='fs-7 text-gray-700'>No Interpreters</span>
                      </div>
                      <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.noInterpreter ?? 0}</span>
                    </div>
                  )}
                  {currentUser?.result.userType !== 'CONSUMER' && (
                    <div className='d-flex justify-content-between align-items-center py-2'>
                      <div className='d-flex align-items-center'>
                        <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(227, 117, 155, 0.7)'}}></span>
                        <span className='fs-7 text-gray-700'>Abandoned</span>
                      </div>
                      <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.abandoned ?? 0}</span>
                    </div>
                  )}
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(24, 28, 50, 0.7)'}}></span>
                      <span className='fs-7 text-gray-700'>Complete</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.completed ?? 0}</span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: '#346beb'}}></span>
                      <span className='fs-7 text-gray-700'>Submitted</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.submitted ?? 0}</span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(74, 198, 215, 0.7)'}}></span>
                      <span className='fs-7 text-gray-700'>In Progress</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.inProgress ?? 0}</span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(45, 170, 190, 0.85)'}}></span>
                      <span className='fs-7 text-gray-700'>Checked In</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.checkedIn ?? 0}</span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center py-2'>
                    <div className='d-flex align-items-center'>
                      <span className='bullet bullet-dot me-2 h-10px w-10px' style={{backgroundColor: 'rgba(228, 230, 239, 0.7)'}}></span>
                      <span className='fs-7 text-gray-700'>Cancelled</span>
                    </div>
                    <span className='fs-7 fw-bold text-gray-800'>{appointmentStatistics?.cancelled ?? 0}</span>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className='d-flex'>
              <div className='me-3'>
                <CalendarSortDropdown showLinguistOption={currentUser?.result.userType === 'SYSTEM'} />
              </div>
              <div className='me-3'>
                <CalandarFilterDropdown
                  fetchAppoinmentDetailsUsingDate={fetchAppoinmentDetailsUsingDate}
                  date={date}
                  data={data}
                />
              </div>

              {(currentUser?.result.userType === 'SYSTEM' ||
                (currentUser?.result.userType === 'CONSUMER' &&
                  (userDetails?.data.opI_ShdTelephonic === true ||
                    userDetails?.data.vrI_ShdVideoInteroreting === true ||
                    userDetails?.data.osI_OnsiteConsecutive === true ||
                    userDetails?.data.osI_OnsiteSimultaneous === true ||
                    userDetails?.data.osI_OnsiteWhisper === true ||
                    userDetails?.data.osI_Onsite === true ||
                    userDetails?.data.other_3rdPartyPlatform === true))) && (
                <div>
                  <Link to='/create-appointment'>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip id='tooltip-filter'>Create Appointment</Tooltip>}
                    >
                      <div>
                        <button type='button' className='btn btn-sm btn-primary btn-icon'>
                          <i className='bi bi-plus fs-2'></i>
                        </button>
                      </div>
                    </OverlayTrigger>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <FullCalendar
            key={`calendar-${sortKey}`}
            ref={calendarRef}
            schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
            height='70vh'
            initialDate={date}
            slotLabelContent={(arg) => {
              const hour = arg.date.getHours()
              const ampm = hour >= 12 ? 'PM' : 'AM'
              const displayHour = hour % 12 || 12
              return `${displayHour} ${ampm}`
            }}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              listPlugin,
              interactionPlugin,
              resourceTimelinePlugin,
            ]}
            initialView='resourceTimeline'
            headerToolbar={false}
            datesSet={handleDateSelect}
            resourceAreaHeaderContent='Appointments'
            resourceAreaWidth='220px'
            resourceOrder='order'
            resources={resources}
            events={events}
            slotMinTime='00:00:00'
            slotMaxTime='24:00:00'
            scrollTime='08:00:00'
            slotDuration='01:00:00'
            editable={false}
            selectable={false}
            eventDrop={(info) => {}}
            eventResize={(info) => {}}
            eventContent={renderEventContent}
          />
        </div>
      </div>
      {isLoading && <CommonLoading />}
    </>
  )
}

const styleSheet = document.createElement('style')
styleSheet.type = 'text/css'
styleSheet.innerText = styles
document.head.appendChild(styleSheet)

export {AppointmentFullCalendar}
